/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Továrna na asynchronní bazény recyklovaných objektů.
 */
class PoolAsyncFactory {
  /**
   * Vytvoří instanci.
   * @param {Class.<PoolAsync>} PoolAsync
   * @param {GenericPool} genericPool
   */
  constructor(PoolAsync, genericPool) {
    this.PoolAsync = PoolAsync;
    this.genericPool = genericPool;
  }

  /**
   * Vytvoří nový bazén.
   * @param {PoolObjectFactory} factory Továrna pro vytváření nových objektů umísťených v bazénu.
   * @param {Object} [opts={}] Nepovinné parametry.
   * @param {number} [opts.max=Infinity] Maximální počet objektů, které má bazén vytvořit.
   * @returns {PoolAsync}
   */
  create(factory, { max = Infinity } = {}) {
    return new this.PoolAsync(factory, this.genericPool, max);
  }
}

export default PoolAsyncFactory;
